import { useMutation } from '@tanstack/react-query'
import { RequestTypes } from '@core/react-query/features/analytics/requestTypes'
import { analyticsKeys } from '@core/react-query/features/analytics'
import { IGeneratedAnalyticsDashboard } from '@core/entities/analytics'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGenerateAnalyticsDashboard = () => {
  return useMutation<
    IGeneratedAnalyticsDashboard,
    RequestErrorType,
    RequestTypes['generateAnalyticsDashboard'],
    unknown
  >({
    mutationFn: (variables: RequestTypes['generateAnalyticsDashboard']) =>
      analyticsKeys.generateAnalyticsDashboard(variables).queryFn(undefined),
  })
}
